// extracted by mini-css-extract-plugin
export var externalLink = "_cd-0";
export var internalLinkLabel = "_cd-1";